import {GenericModel} from '../../shared/model/generic.model';

export class Relatorio extends GenericModel {

    public nome: string;
    
}
